export default "__VITE_ASSET__cf3qGma1__"